import { useLang } from "@/i18n/LanguageContext";

// Numero VELORA JDM — sempre in formato internazionale senza + né spazi per l'URL wa.me
const WA_NUMBER = "393274803439";
const WA_MESSAGES = {
    it: "Ciao VELORA JDM, vorrei maggiori informazioni sulle esperienze in pista",
    en: "Hi VELORA JDM, I'd like more information about your track experiences",
};

export function buildWhatsAppUrl(lang = "it", customText = null) {
    const text = customText || WA_MESSAGES[lang] || WA_MESSAGES.it;
    return `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(text)}`;
}

export const WA_DISPLAY = "+39 327 480 3439";

// Icona WhatsApp inline SVG (evita dipendenze extra)
export const WhatsAppIcon = ({ size = 24 }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={size} height={size} fill="currentColor" aria-hidden="true">
        <path d="M20.52 3.48A11.86 11.86 0 0 0 12.05 0C5.46 0 .1 5.36.1 11.95c0 2.1.55 4.16 1.6 5.97L0 24l6.24-1.64a11.9 11.9 0 0 0 5.8 1.48h.01c6.59 0 11.95-5.36 11.95-11.95a11.86 11.86 0 0 0-3.48-8.41ZM12.05 21.86h-.01a9.9 9.9 0 0 1-5.05-1.38l-.36-.22-3.7.97.99-3.61-.23-.37a9.88 9.88 0 0 1-1.52-5.3c0-5.47 4.45-9.92 9.93-9.92 2.65 0 5.15 1.04 7.03 2.91a9.87 9.87 0 0 1 2.91 7.02c0 5.48-4.45 9.9-9.99 9.9Zm5.44-7.42c-.3-.15-1.76-.87-2.03-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07-.3-.15-1.26-.46-2.4-1.48-.89-.79-1.49-1.77-1.66-2.07-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.62-.92-2.22-.24-.58-.49-.5-.67-.51h-.57c-.2 0-.52.07-.79.37-.27.3-1.04 1.02-1.04 2.49 0 1.47 1.07 2.89 1.22 3.09.15.2 2.11 3.22 5.11 4.51.71.31 1.27.49 1.7.62.71.23 1.36.2 1.87.12.57-.08 1.76-.72 2-1.42.25-.7.25-1.29.17-1.42-.07-.13-.27-.2-.57-.35Z" />
    </svg>
);

export function FloatingWhatsApp() {
    const { lang } = useLang();
    return (
        <a
            href={buildWhatsAppUrl(lang)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="floating-whatsapp"
            aria-label="Contattaci su WhatsApp"
            className="fixed bottom-5 right-5 z-40 flex items-center gap-2 bg-[#25D366] hover:bg-[#1DA851] text-white shadow-[0_8px_24px_rgba(37,211,102,0.35)] hover:shadow-[0_10px_30px_rgba(37,211,102,0.55)] rounded-full pl-3 pr-4 py-3 transition-all duration-200 hover:scale-105 md:pl-3 md:pr-5"
            style={{ animation: "wa-pulse 2.5s ease-in-out infinite" }}
        >
            <WhatsAppIcon size={26} />
            <span className="font-display uppercase tracking-widest text-xs hidden sm:inline">WhatsApp</span>
            <style>{`
              @keyframes wa-pulse {
                0%, 100% { box-shadow: 0 8px 24px rgba(37,211,102,0.35), 0 0 0 0 rgba(37,211,102,0.7); }
                50% { box-shadow: 0 8px 24px rgba(37,211,102,0.35), 0 0 0 14px rgba(37,211,102,0); }
              }
            `}</style>
        </a>
    );
}

export function WhatsAppLink({ className = "", showIcon = true, label, tid = "wa-link" }) {
    const { lang } = useLang();
    const text = label || (lang === "en" ? "Chat on WhatsApp" : "Scrivici su WhatsApp");
    return (
        <a
            href={buildWhatsAppUrl(lang)}
            target="_blank"
            rel="noopener noreferrer"
            data-testid={tid}
            className={`inline-flex items-center gap-2 text-[#25D366] hover:text-[#1DA851] transition-colors duration-150 ${className}`}
        >
            {showIcon && <WhatsAppIcon size={18} />}
            <span>{text}</span>
        </a>
    );
}
